<div class="search-results__list">
  <sharry-loading
    class="search-results__loading-full"
    [ngClass]="{
      hidden: !busy && (headerSearchService.isBusy$ | async) === false,
    }"
    [fullscreen]="true"></sharry-loading>
  <section
    style="display: contents"
    [ngClass]="{
      hidden: !(bannerSearchTerm && bannerSearchKind) || busy || (headerSearchService.isBusy$ | async) === true,
    }">
    <sharry-search-banner
      [searchTerm]="bannerSearchTerm"
      [searchKind]="bannerSearchKind"></sharry-search-banner>
  </section>
  @if (cards$ | async; as cards) {
    <section
      style="display: contents"
      [ngClass]="{
        hidden: busy || (headerSearchService.isBusy$ | async) === true,
      }">
      <div class="search-results__sub-header">
        <h3
          class="search-results__sub-header__title"
          [innerHTML]="
            (!!cards.length ? 'search-results.results' : 'search-results.no-results') + (value ? '' : '-no-value')
              | i18next: { total: total, value: value }
          "></h3>
        <!-- <p
          *ngIf="!!cards.length"
          class="bigger search-results__list-subtitle">
          {{ 'search-results.results.hint' | i18next }}
        </p> -->
        @if (!cards.length && !isNearMe) {
          <p class="bigger search-results__list-subtitle">
            {{ 'search-results.no-results-hint' | i18next }}&nbsp;<a [routerLink]="'community' | routeTranslate">{{
              'search-results.no-results-hint-link' | i18next
            }}</a>
          </p>
        }
        @if (!cards.length && isNearMe) {
          <p class="bigger search-results__list-subtitle">
            {{ 'search-results.no-results-hint.nearme-1' | i18next }}&nbsp;<a
              [routerLink]="'community' | routeTranslate"
              [queryParams]="{ hashtag: value }"
              >{{ 'search-results.no-results-hint-link' | i18next }}</a
            >
            {{ 'search-results.no-results-hint.nearme-2' | i18next }}
          </p>
        }
        @if (!cards.length) {
          <div class="search-results__sub-header__separator"></div>
        }
      </div>
      @if (!cards.length) {
        <h4
          style="padding: 0 var(--content-padding); margin-top: 0"
          class="search-results__sub-header__title--maybe">
          {{ 'search-results.fallback-search.suggested' | i18next }}
        </h4>
      }
      <div class="search-results__sharries">
        <sharry-content-card-list
          classes="content-card-list--trip"
          mode="template"
          [cards]="cards | carderize"></sharry-content-card-list>
        @if (cards.length) {
          <div class="search-results__button-container">
            @if (searchBusy) {
              <sharry-loading></sharry-loading>
            }
            <small
              [ngStyle]="{
                'margin-bottom': cards.length === total ? '1.5rem' : '0',
              }"
              ><strong>{{ cards.length }}</strong> {{ 'search-results.of-total' | i18next: { total: total } }}</small
            >
          </div>
        }
        @if (!cards.length) {
          @if (fallbackCards$ | async; as fallbackCards) {
            <sharry-content-card-list
              classes="content-card-list--trip"
              [cards]="fallbackCards | carderize"></sharry-content-card-list>
            <div class="search-results__button-container">
              @if (searchBusy) {
                <sharry-loading></sharry-loading>
              }
              <small
                [ngStyle]="{
                  'margin-bottom': fallbackCards.length === fallbackTotal ? '1.5rem' : '0',
                }"
                ><strong>{{ fallbackCards.length }}</strong> di {{ fallbackTotal }}</small
              >
            </div>
          }
        }
        @if (!!cards.length) {
          <!--PLACE UTILITIES-->
          @if (placeUtilities$ | async; as placeUtilities) {
            @if ((placeUtilities | keyvalue).length) {
              <div class="search-results__utilities">
                <p class="search-results__utilities__title">
                  {{ 'search-results.utilities.title' | i18next }}
                </p>
                <sharry-masonry-grid
                  [masonryElements]="placeUtilities | keyvalue"
                  [masonryGrid]="{ lg: 4, md: 3, sm: 2, xs: 1 }"
                  [masonryTemplate]="cardTemplate"></sharry-masonry-grid>
                <ng-template
                  #cardTemplate
                  let-card>
                  <div
                    class="search-results__utilities__family"
                    [id]="card.key">
                    @if (card.key) {
                      <p class="bigger semibold">
                        <sharry-icon
                          svgClass="search-results__utilities__icon"
                          [name]="$any(utilityIcons)[card.key]"></sharry-icon>
                        {{ 'search-results.utilities.' + card.key | i18next }}
                      </p>
                    }
                    @for (place of card.value; track place.id) {
                      <a
                        target="_blank"
                        sharryEllipsisTooltip
                        href="https://www.google.com/maps/search/?api=1&query={{ place.latitude }},{{
                          place.longitude
                        }}"
                        >{{ place.name }}</a
                      >
                    }
                  </div>
                </ng-template>
                <div class="search-results__utilities__report">
                  <sharry-report
                    [title]="'search-results.utilities.new_content' | i18next"
                    [isPlaceUtility]="true"
                    [icon]="'binoculars'"
                    [data]="{
                      reportedEntityId: reportedEntityId,
                      reportedEntityType: reportableEntityEnum.Place,
                    }"></sharry-report>
                  <sharry-report
                    [title]="'search-results.utilities.not_correct' | i18next"
                    [isPlaceUtility]="true"
                    [icon]="'bell-ringing'"
                    [data]="{
                      reportedEntityId: reportedEntityId,
                      reportedEntityType: reportableEntityEnum.Place,
                    }"></sharry-report>
                </div>
              </div>
            }
          }
        }
        <!--        <section class="search-results__banner">
          <div
            lazybg
            class="search-results__banner__text">
            <h3>{{ 'search-results.what-community' | i18next }}</h3>
            <a
              class="mat-mdc-button sharry-big rounded"
              [routerLink]="'community' | routeTranslate">
              <sharry-icon
                name="note-pencil"
                type="phosphor"
                svgClass="svg-icon"></sharry-icon>
              {{ 'search-results.see-post' | i18next }}
            </a>
          </div>
        </section>-->
      </div>
    </section>
  }
</div>

<ng-template
  #fallbackSearchTemplate
  let-data>
  <div class="search-results__fallback-search">
    <p>
      {{ 'search-results.fallback.snackbar-title' | i18next }}
      <a
        [routerLink]="'search-results' | routeTranslate"
        [queryParams]="data.fallbackParams"
        [replaceUrl]="true"
        [state]="{ refresh: true }"
        (click)="busy = true; snackBarRef.closeWithAction()"
        >{{ data.place.placeName | stringReplace: ', Italia' : '' }}</a
      >?
    </p>
    <button
      mat-button
      color="primary"
      class="sharry-small"
      (click)="snackBarRef.closeWithAction()">
      {{ 'close' | i18next }}
    </button>
  </div>
</ng-template>
